module.exports = "/images/vendor/flag-icon-css/flags/1x1/gw.svg?5ecbd93cc2eeec1d063377170a3d83ee";